import { SETTING_URL } from ".";

export const MAIL_TEMPLATE = "mail-template";
export const USER_ASSIGNMENT = "user-assignment";
export const MANAGER_SETTING = "manager-setting";
export const MAIL_TEMPLATE_URL = `/${SETTING_URL}/${MAIL_TEMPLATE}`;
export const USER_ASSIGNMENT_URL = `/${SETTING_URL}/${USER_ASSIGNMENT}`;
export const MANAGER_SETTING_URL = `/${SETTING_URL}/${MANAGER_SETTING}`;
